import { render, staticRenderFns } from "./PersonalHonor.vue?vue&type=template&id=811e5782&scoped=true"
import script from "./PersonalHonor.vue?vue&type=script&lang=js"
export * from "./PersonalHonor.vue?vue&type=script&lang=js"
import style0 from "./PersonalHonor.vue?vue&type=style&index=0&id=811e5782&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "811e5782",
  null
  
)

export default component.exports